import React from "react";
import "./Footer.scss";

const Footer = () => {
  return (
    <div className="footer animate__animated animate__fadeInUp">
      <div><p>Bulit with React, HTML5, SCSS &nbsp;&nbsp;&nbsp;&nbsp; March - 2021 </p></div>
      <div className="links-container">
        <a
          href="https://www.linkedin.com/in/meisam-e-zarghani-b2167691"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-linkedin-in"></i>
        </a>
        <a
          href="https://github.com/Erwin6997"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-github"></i>
        </a>
        <a
          href="https://twitter.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-twitter"></i>
        </a>
        <a
          href="https://www.instagram.com/erwin.zrni/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="fab fa-instagram"></i>
        </a>
        <a
          href="/CV.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fas fa-file-alt"></i>
        </a>
      </div>
    </div>
  );
};

export default Footer;
